import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Zoom from 'react-reveal/Zoom';
import Randomizer from '../components/randomizer';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "odyssey-dance-theatre",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#odyssey-dance-theatre",
        "aria-label": "odyssey dance theatre permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Odyssey Dance Theatre`}</h1>
    <h2 {...{
      "id": "shut-up-and-dance---2022",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#shut-up-and-dance---2022",
        "aria-label": "shut up and dance   2022 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Shut Up and Dance - 2022`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Content published as of March 1, 2022`}</p>
    </blockquote>
    <Link to="/title-page" mdxType="Link">
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQX/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQD/2gAMAwEAAhADEAAAAeWlrRc4YQxxDZGl3//EABsQAAICAwEAAAAAAAAAAAAAAAECABIDERMQ/9oACAEBAAEFAhhaHGwjipxsu2rV67UGMRqdDzYg+f/EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAEDAQE/ASP/xAAXEQADAQAAAAAAAAAAAAAAAAABAiBR/9oACAECAQE/AVOx/8QAHxAAAQMDBQAAAAAAAAAAAAAAAAERMRAhQRMiQlFh/9oACAEBAAY/Ak9MEmYIVyw/HsstNN9okJT/xAAdEAACAgIDAQAAAAAAAAAAAAABEQAhMUEQUXFh/9oACAEBAAE/ISRjVipkjBUEDWoSKCAAb24b2w/PsI86gqUhvE3ffZ412zxAKBAVDMQ7n//aAAwDAQACAAMAAAAQX+yM/8QAGREAAgMBAAAAAAAAAAAAAAAAAREAECFR/9oACAEDAQE/EF7AStv/xAAZEQACAwEAAAAAAAAAAAAAAAABEQAQIUH/2gAIAQIBAT8QYMQgPIH2v//EACAQAQACAgICAwEAAAAAAAAAAAEAESExQWFxkRBRgaH/2gAIAQEAAT8QshGwsUeJnSUW0XUEs6NhK6yROy2luCzPbFDcqjyKPpxk6lleDk59wPCwaORrJCVZAos9f34K6QYN93Vw45eR5PcQ0X8n/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/suad-2022/static/4c92cb1d258639654f4861942bec33fe/8ac56/suad-cover.webp 240w", "/suad-2022/static/4c92cb1d258639654f4861942bec33fe/d3be9/suad-cover.webp 480w", "/suad-2022/static/4c92cb1d258639654f4861942bec33fe/87ca7/suad-cover.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/suad-2022/static/4c92cb1d258639654f4861942bec33fe/09b79/suad-cover.jpg 240w", "/suad-2022/static/4c92cb1d258639654f4861942bec33fe/7cc5e/suad-cover.jpg 480w", "/suad-2022/static/4c92cb1d258639654f4861942bec33fe/1a144/suad-cover.jpg 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/suad-2022/static/4c92cb1d258639654f4861942bec33fe/1a144/suad-cover.jpg",
              "alt": "Shut Up and Dance cover",
              "title": "Shut Up and Dance cover",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </Link>
    <blockquote>
      <p parentName="blockquote">{`📱 Please use the menu to explore our new mobile friendly program.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`📖 If you prefer a traditional “page turning” format as with print publications, `}<a parentName="p" {...{
          "href": "/suad-2022/digital-program"
        }}>{`please click here`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "quick-navigation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#quick-navigation",
        "aria-label": "quick navigation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Quick Navigation`}</h3>
    <section className="home-list">
      <Zoom mdxType="Zoom">
  <Link to="/chicago-nights" alt="Link to Chicago Nights title page." className="home-column" mdxType="Link">
    Chicago Nights
  </Link>
      </Zoom>
      <Zoom mdxType="Zoom">
  <Link to="/romeo-juliet" alt="Link to Romeo+Juliet title page." className="home-column" mdxType="Link">
    Romeo+Juliet
  </Link>
      </Zoom>
      <Zoom mdxType="Zoom">
  <Link to="/let-it-be" alt="Link to let it be title page." className="home-column" mdxType="Link">
    Let It Be
  </Link>
      </Zoom>
      <Zoom mdxType="Zoom">
  <Link to="/sledgehammer" alt="Link to let it be title page." className="home-column" mdxType="Link">
    Sledgehammer
  </Link>
      </Zoom>
      <Zoom mdxType="Zoom">
  <Link to="/digital-program" alt="Link to Shut Up and Dance - Salt Lake City Flipbook." className="home-column" mdxType="Link">
    Flipbook
  </Link>
      </Zoom>
    </section>
    <Randomizer mdxType="Randomizer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      